import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress  } from 'antd';
import {balanceOf,signer, transfer} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';

import '../invite/index.less'
import {getGameIndex} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Game = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [show0,setShow0] = useState(true)
    const [show1,setShow1] = useState(true)
    const [show2,setShow2] = useState(false)
const navigate = useNavigate()

    const [spacex_n,setSpacexN] = useState("")
    // const [marsx_n,setSpacexxN] = useState("")
    const [usdt_n,setUsdtN] =useState("")

    const [marsBonus,setSpacexBonus] = useState("")
    // const [marsxBonus,setSpacexxBonus] = useState("")
    const [usdtBonus,setUsdtBonus] =useState("")

    const [userSpacexJoinToday,setUserSpacexJoinToday] =useState("")
    // const [userSpacexxJoinToday,setUserSpacexxJoinToday] =useState("")
    const [userUsdtJoinToday,setUserUsdtJoinToday] =useState("")

    const [userSpacexJoinAll,setUserSpacexJoinAll] =useState("")
    // const [userSpacexxJoinAll,setUserSpacexxJoinAll] =useState("")
    const [userUsdtJoinAll,setUserUsdtJoinAll] =useState("")

    const [userSpacexWinToday,setUserSpacexWinToday] =useState("")
    // const [userSpacexxWinToday,setUserSpacexxWinToday] =useState("")
    const [userUsdtWinToday,setUserUsdtWinToday] =useState("")

    const [userSpacexWinAll,setUserSpacexWinAll] =useState("")
    // const [userSpacexxWinAll,setUserSpacexxWinAll] =useState("")
    const [userUsdtWinAll,setUserUsdtWinAll] =useState("")

    const [bossSpacexJoinToday,setBossSpacexJoinToday] =useState("")
    // const [bossSpacexxJoinToday,setBossSpacexxJoinToday] =useState("")
    const [bossUsdtJoinToday,setBossUsdtJoinToday] =useState("")

    const [bossSpacexJoinAll,setBossSpacexJoinAll] =useState("")
    // const [bossSpacexxJoinAll,setBossSpacexxJoinAll] =useState("")
    const [bossUsdtJoinAll,setBossUsdtJoinAll] =useState("")

    const [bossSpacexWinToday,setBossSpacexWinToday] =useState("")
    // const [bossSpacexxWinToday,setBossSpacexxWinToday] =useState("")
    const [bossUsdtWinToday,setBossUsdtWinToday] =useState("")

    const [bossSpacexWinAll,setBossSpacexWinAll] =useState("")
    // const [bossSpacexxWinAll,setBossSpacexxWinAll] =useState("")
    const [bossUsdtWinAll,setBossUsdtWinAll] =useState("")
    
    const [gameLevel,setGameLevel] =useState("")
    const [gameBig,setGameBig] =useState("")





  
    
    

  

    
 














    const _getGameIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getGameIndex().then(res=>{
            if(res.code === 0 ){

                
              
               setUsdtN(res.data.usdt_n)
               setSpacexN(res.data.spacex_n)
               //setSpacexxN(res.data.marsx_n)
                

               setUserSpacexJoinToday(res.data.userSpacexJoinToday)
               setUserSpacexJoinAll(res.data.userSpacexJoinAll)
               //setUserSpacexxJoinToday(res.data.userSpacexxJoinToday)
               //setUserSpacexxJoinAll(res.data.userSpacexxJoinAll)
               setUserUsdtJoinToday(res.data.uerUsdtJoinToday)
               setUserUsdtJoinAll(res.data.userUsdtJoinAll)

               setUserSpacexWinToday(res.data.userSpacexWinToday)
               setUserSpacexWinAll(res.data.userSpacexWinAll)
               //setUserSpacexxWinToday(res.data.userSpacexxWinToday)
               //setUserSpacexxWinAll(res.data.userSpacexxWinAll)
               setUserUsdtWinToday(res.data.userUsdtWinToday)
               setUserUsdtWinAll(res.data.userUsdtWinAll)

                setBossSpacexJoinToday(res.data.bossSpacexJoinToday)
               setBossSpacexJoinAll(res.data.bossSpacexJoinAll)
              // setBossSpacexxJoinToday(res.data.bossSpacexxJoinToday)
               //setBossSpacexxJoinAll(res.data.bossSpacexxJoinAll)
               setBossUsdtJoinToday(res.data.bossUsdtJoinToday)
               setBossUsdtJoinAll(res.data.bossUsdtJoinAll)

                setBossSpacexWinToday(res.data.bossSpacexWinToday)
               setBossSpacexWinAll(res.data.bossSpacexWinAll)
               //setBossSpacexxWinToday(res.data.bossSpacexxWinToday)
               //setBossSpacexxWinAll(res.data.bossSpacexxWinAll)
               setBossUsdtWinToday(res.data.bossUsdtWinToday)
               setBossUsdtWinAll(res.data.bossUsdtWinAll)

               //setSpacexxBonus(res.data.marsx_bonus)
               setSpacexBonus(res.data.mars_bonus)
               setUsdtBonus(res.data.usdt_bonus)

               setGameLevel(res.data.game_level)
               setGameBig(res.data.game_big)
     
                // if(res.data.minted >0){
                //     let _par =  Math.round(res.data.minted / 5000000 *10000)/100
                //     if(_par >100){
                //         _par = 100
                //     }
                //     setPar(_par)
                // }
                

                    

                    //console.log(_par)
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

 



  


 

    const goGame = (e) =>{
        // message.error(t('g.暂未开始'))
        //     return
        if(e==0){
            if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
            navigate("/game160",{
                state:{
                    address:props.address
                }
            })
        }else if(e==2){
            // message.error(t('g.暂未开始'))
            // return
            if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
             navigate("/game1",{
                state:{
                    address:props.address
                }
            })
       
            
        }else{
             message.error(t('g.暂未开始'))
            return
        }
       

        
        
    }

    useEffect(() => {
             window.scrollTo(0, 0)
            _getGameIndex()

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
    
            <Head/>
            
            <div  className=" gameWebBg w-full lg:w-1/3   pt-20 text-white flex flex-col " >
                <div className='w-full lg:w-1/3 px-0   min-h-[104px]  flex flex-row justify-center '>
                    
                    <div className='w-2/3 pl-4 flex flex-col z-40 items-center justify-center'>
                        <img className='mt-1  '  src={require('../../assets/game/title.png')} style={{"width":"138px"}}></img>
                        <span className='mt-[9px] text-text2 text-[10px]' >PREDICT PLAY & WIN</span>
                        <span className='mt-[5px] text-gray-400 text-[9px] text-center' >Choose your game mode,predict the hash and win $doge rewards</span>
                       
                        

                    </div>
                    
                </div>
            
                <div className=" mt-2 h-[100px] mx-4 flex flex-row justify-center items-center  gameAssetbt">
                    <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-text1'><CountUp start={0} end={spacex_n} duration="1" decimals={2} /></span>
                            <span className='text-[10px] mt-2 text-gray-300'>SPACEX</span>
                    </div>
                    <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                     <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-text1'><CountUp start={0} end={usdt_n} duration="1" decimals={2} /></span>
                            <span className='text-[10px] mt-2 text-gray-300'>USDT </span>
                    </div>
                    {/* <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                    <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-text1'><CountUp start={0} end={0} duration="1" decimals={2} /></span>
                            <span className='text-[10px] mt-2 text-gray-300'>BNB</span>
                    </div> */}
                    
                </div>

                    <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(0)} className='  relative flex flex-row justify-center items-end'>
                        {/* <span className=' text-base text-white absolute bottom-7'>{t('game.量子奇偶')}</span> */}
                        <img alt='rr' style={{"width":"168px"}} src={require('../../assets/game/60.png')}></img>
                    </div>

                    <div onClick={()=>goGame(2)} className='  relative flex flex-row justify-center items-end'>
                        {/* <span className=' text-base text-white absolute bottom-7'>{t('game.30秒奇偶')}</span> */}
                        <img alt='rr' style={{"width":"168px"}} src={require('../../assets/game/30.png')}></img>
                    </div>
                   
                    
                </div>

                {/* 0 */}

                
                

                 

                {/*  */}
                {/* 1 */}

                {
                    !show1?(
                        <div className='mx-4 h-14 mt-8 gameTitle1 flex flex-row justify-center items-center relative'>
                            <div className=' w-full flex flex-row justify-end items-center absolute right-0'>
                                <img onClick={()=>setShow1(true)} alt='rr' className='mr-6' src={require('../../assets/bg/game/b.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <span className=" text-base text-text-act">{t('game.用户动态')}</span>

                        </div>
                    ):(
                        <div className='mx-4 h-[449px] mt-8 nftHold flex flex-col  items-center'>
                            <div className=' w-full h-14 flex flex-row justify-center items-center relative'>
                                <span className=" text-xs text-text-act">{t('game.用户动态')}</span>
                                {/* <img onClick={()=>setShow1(false)} alt='rr' className='mr-6 absolute right-0' src={require('../../assets/bg/game/t.png')} style={{"width":"16px","height":"16px"}}></img> */}
                            </div>
                            <div className=' w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.今日流量')} SPACEX</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计流量')} SPACEX</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.当日盈亏')} SPACEX</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计盈亏')} SPACEX</span>
                                </div>
                            </div>
                            {/* <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexxJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} MARSX</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexxJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} MARSX</span>
                                </div>
                            </div> */}
                            {/* <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexxWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} MARSX</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userSpacexxWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} MARSX</span>
                                </div>
                            </div> */}
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.今日流量')} USDT</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计流量')} USDT</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.当日盈亏')} USDT</span>
                                </div>
                                <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计盈亏')} USDT</span>
                                </div>
                            </div>

                        </div>
                    )
                }


                {
                    !show0?(
                        <div className='mx-4 h-14 mt-8 gameTitle1 flex flex-row justify-center items-center relative'>
                            <div className=' w-full flex flex-row justify-end items-center absolute right-0'>
                                <img onClick={()=>setShow0(true)} alt='rr' className='mr-6' src={require('../../assets/bg/game/b.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <span className=" text-base text-text-act">{t('game.平台动态')}</span>

                        </div>
                    ):(
                        <div className='mx-4 h-[449px] mt-8 nftHold flex flex-col  items-center'>
                            <div className=' w-full h-14 flex flex-row justify-center items-center relative'>
                                <span className=" text-xs text-text-act">{t('game.平台动态')}</span>
                                {/* <img onClick={()=>setShow0(false)} alt='rr' className='mr-6 absolute right-0' src={require('../../assets/bg/game/t.png')} style={{"width":"16px","height":"16px"}}></img> */}
                            </div>
                            <div className=' w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossSpacexJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.今日流量')} SPACEX</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#FF7D0030"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossSpacexJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计流量')} SPACEX</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossSpacexWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.当日盈亏')} SPACEX</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#FF7D0030"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossSpacexWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计盈亏')} SPACEX</span>
                                </div>
                            </div>
                           
                           
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossUsdtJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.今日流量')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#FF7D0030"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossUsdtJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计流量')} USDT</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossUsdtWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.当日盈亏')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#FF7D0030"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-xs text-white'><CountUp start={0} end={bossUsdtWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-[9px] mt-2 text-text1'>{t('game.累计盈亏')} USDT</span>
                                </div>
                            </div>

                        </div>
                    )
                }
                

 

                {/*  */}
                 {/* 2 */}

               
                

                 

                {/*  */}

                {/* <div className='mx-4 h-16 mt-8 px-4 gameTitle3 flex flex-row justify-between items-center relative'>
                    <span className=" text-sm text-white">{t('game.我的级别')}:{gameLevel==0?t('game.普通船员'):gameLevel==1?t('game.星际探索者'):gameLevel==2?t('game.星际领主'):gameLevel==3?t('game.银河统帅'):t('game.宇宙元老')}</span>
                    <img alt='rr' className='mr-1' src={require('../../assets/bg/share/title.png')} style={{"width":"30px","height":"30px"}}></img>
                </div> */}

                {/* <div className='mx-4 h-20 mt-8 px-4 gameTitle3 flex flex-row justify-start items-start relative'>
                    <div className=" h-20 text-sm text-gray-300 flex flex-row items-center">{t('game.游戏基金总额')}</div>
                    <div className='h-20 flex flex-col items-start justify-center ml-4'>
                        <span className=" text-xs text-white mb-1">MARS：<CountUp start={0} end={marsBonus} duration="1" decimals={2} /></span>
                     <span className=" text-xs text-white mb-1">MARSX：<CountUp start={0} end={marsxBonus} duration="1" decimals={2} /></span>
                      <span className=" text-xs text-white mb-1">USDT：<CountUp start={0} end={usdtBonus} duration="1" decimals={2} /></span>
                    </div>
                    
                    <img alt='rr' className=' absolute right-0' src={require('../../assets/bg/game/image.png')} style={{"width":"77px","height":"77px"}}></img>
                </div> */}

                 {/* <div className=' w-full h-6 mx-auto mt-[40px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game.游戏排行')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div> */}

                {/* <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(0)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.量子奇偶')}</span>
                        <img alt='rr' className=' w-40 h-60' src={require('../../assets/bg/game/g1.png')}></img>
                    </div>
                   <div onClick={()=>goGame(1)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.尾数天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g2.png')}></img>
                    </div>
                    
                </div> */}
                {/* <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(1)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.尾数天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g2.png')}></img>
                    </div>
                   <div onClick={()=>goGame(3)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.30秒天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g4.png')}></img>
                    </div>
                    
                </div> */}

                                                        

                {/*  */}

               

                    <div className=' w-full h-[100px]'></div>

            </div>
            


           <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(Game);
